import { StrictMode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';

import '@/styles/global.css';

import App from './App.tsx';
import { queryClient } from './lib/query-client.ts';
import { Toaster } from './components/ui/sonner.tsx';
import { TooltipProvider } from './components/ui/tooltip';
import { SentryWrapper } from './components/shared/sentry-wrapper.tsx';
import { initSentry } from './config/sentry.ts';

initSentry();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryWrapper>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={200}>
          <Toaster
            className="custom-sonner-toast"
            position="top-right"
            richColors
            closeButton={true}
          />
          <App />
        </TooltipProvider>
      </QueryClientProvider>
    </SentryWrapper>
  </StrictMode>,
);
